import { Component } from '@angular/core';
import { AihLaunchpadCoreModule } from "aih-launchpad-core";
import { AdminRoutingModule } from "../admin/admin-routing.module";

@Component({
  selector: 'app-app-wrapper',
  imports: [AihLaunchpadCoreModule, AdminRoutingModule],
  templateUrl: './app-wrapper.component.html',
  styleUrl: './app-wrapper.component.sass'
})
export class AppWrapperComponent {

}
